
import React, { useEffect, useState } from 'react';
import { getBackendURL } from './utils';

const AdminDashboard = ({ accessToken }) => {
  const [adminClientInfoData, setAdminClientInfoData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetch(getBackendURL() + '/client', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
    })
      .then((res) => res.ok ? res.json() : Promise.reject('Failed to fetch admin data'))
      .then((data) => setAdminClientInfoData(data || []))
      .catch((err) => console.error('Error fetching admin data:', err))
      .finally(() => setLoading(false));
  }, [accessToken]);

  if (loading) {
    return <p>Loading admin data...</p>;
  }

  return (
    <div style={{marginTop: 1000}} >
      <h3>Admin Dashboard</h3>

      {adminClientInfoData.length === 0 ? (
        <p>No client info data available.</p>
      ) : (
        <ul>
          {adminClientInfoData.map((item, index) => (
            <li key={index}>
              <p><b>ID:</b> {item.id}</p>
                <p><b>Pre User Email:</b> {item.pre_user_email}</p>
                {/* <p><b>Trainer Info:</b> {JSON.stringify(item.trainer_info)}</p>
                <p><b>User Info:</b> {JSON.stringify(item.user)}</p> */}
                {/* wait do their ids separately then do stringify but handle nones better  */}
                <p><b>Trainer Info ID:</b> {item.trainer_info_id}</p>
                {/* <p><b>Trainer info:</b> {item.trainer_info ? JSON.stringify(item.trainer_info) : 'No trainer info'}</p> */}
                <p><b>User ID:</b> {item.user_id ? item.user_id : 'No user ID'}</p>
                <p><b>User info:</b> {item.user ? JSON.stringify(item.user) : 'No user info'}</p>
                <p><b>Timeslot Sunday:</b> {item.timeslot_sunday}</p>
                <p><b>Timeslot Monday:</b> {item.timeslot_monday}</p>
                <p><b>Timeslot Tuesday:</b> {item.timeslot_tuesday}</p>
                <p><b>Timeslot Wednesday:</b> {item.timeslot_wednesday}</p>
                <p><b>Timeslot Thursday:</b> {item.timeslot_thursday}</p>
                <p><b>Timeslot Friday:</b> {item.timeslot_friday}</p>
                <p><b>Timeslot Saturday:</b> {item.timeslot_saturday}</p>
                <p><b>Sent Email Date:</b> {item.sent_email_date}</p>
                <p><b>Consent Timestamp:</b> {item.consent_timestamp}</p>
                <p><b>IP Address:</b> {item.ip_address}</p>
                {/* other stuff doesnt matter afaik  */}
            </li>
          ))}
        </ul>
      )}



    </div>
  );
};

export default AdminDashboard;